import { render, staticRenderFns } from "./InserirVisualizarOrdemJudicialModal.vue?vue&type=template&id=beb23772&scoped=true&"
import script from "./InserirVisualizarOrdemJudicialModal.vue?vue&type=script&lang=js&"
export * from "./InserirVisualizarOrdemJudicialModal.vue?vue&type=script&lang=js&"
import style0 from "./InserirVisualizarOrdemJudicialModal.vue?vue&type=style&index=0&id=beb23772&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb23772",
  null
  
)

export default component.exports